'use strict';

/**
 * Enum definition file for where a price tag field is edited: on the tag or in the restrictions panel.
 *
 * @module data/enums/price-tag-field-sections
 */
module.exports = {
    tag: 'tag',
    restrictions: 'restrictions',
};
